module.exports = __webpack_public_path__ + "static/img/t5.55500d27.png";